import React from 'react'
import { CircularProgress } from '@mui/material'

type Props = { size?: number | string }
export const Spinner = (props: Props) => <CircularProgress color='primary' size={props.size} />
